import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["width", "height", "src"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import LazyImage from './LazyImage';
import AspectRatioBox from '../layout/AspectRatioBox';
import { IMAGE_FORMATS } from './imageFormats';
import isContentfulAsset from '../../utils/isContentfulAsset';
import { jsx as _jsx } from "react/jsx-runtime";

var Image = function Image(_ref) {
  var width = _ref.width,
      height = _ref.height,
      src = _ref.src,
      props = _objectWithoutProperties(_ref, _excluded);

  var extension = src.split('.').pop().split('?')[0].split('#')[0];
  var imageType = IMAGE_FORMATS[extension] ? extension : '*';
  var placeholder;

  var original = _defineProperty({}, imageType, src); // TODO: add possibility to pass placeholder in props


  if (width && height && isContentfulAsset(src)) {
    var placeholderWidth = Math.floor(width / 20);
    var placeholderHeight = Math.floor(height / 20);
    placeholder = _defineProperty({}, imageType, "".concat(src, "?w=").concat(placeholderWidth, "&h=").concat(placeholderHeight));

    if (extension !== 'svg') {
      original.webp = "".concat(src, "?fm=webp&q=65");
      placeholder.webp = "".concat(src, "?fm=webp&w=").concat(placeholderWidth, "&h=").concat(placeholderHeight, "&q=65");
    }
  }

  return width && height ? /*#__PURE__*/_jsx(AspectRatioBox, {
    $width: width,
    $height: height,
    children: /*#__PURE__*/_jsx(LazyImage, _objectSpread({
      width: width,
      height: height,
      original: original,
      placeholder: placeholder
    }, props))
  }) : /*#__PURE__*/_jsx(LazyImage, _objectSpread({
    original: original,
    placeholder: placeholder
  }, props));
};

export default Image;